module.exports = __webpack_public_path__ + "static/media/ic_clone_account.28a42aaa.svg";